(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-utils/assisted-focus-scroll/assets/javascripts/use-assisted-focus-scroll.js') >= 0) return;  svs.modules.push('/components/lb-utils/assisted-focus-scroll/assets/javascripts/use-assisted-focus-scroll.js');
"use strict";


const {
  useEffect,
  useRef
} = React;
const INTERACTIVE_ELEMENT_TAGS = ['input', 'button', 'select', 'textarea', 'a'];
function scrollIntoViewWithOffset(element, _ref) {
  let {
    offsetTop = 95,
    offsetBottom = 95
  } = _ref;

  const rect = element.getBoundingClientRect();
  const absoluteTop = rect.top + window.pageYOffset;
  const absoluteBottom = rect.bottom + window.pageYOffset;
  const viewTop = window.pageYOffset + offsetTop;
  const viewBottom = window.pageYOffset + window.innerHeight - offsetBottom;
  if (absoluteTop < viewTop) {
    window.scrollTo({
      top: absoluteTop - offsetTop,
      behavior: 'smooth'
    });
  } else if (absoluteBottom > viewBottom) {
    window.scrollTo({
      top: absoluteBottom - window.innerHeight + offsetBottom,
      behavior: 'smooth'
    });
  }
}
const useAssistedFocusScroll = _ref2 => {
  let {
    offsetTop = 95,
    offsetBottom = 95
  } = _ref2;
  const wrapperRef = useRef(null);
  useEffect(() => {
    const wrapper = wrapperRef.current;
    if (!wrapper) {
      return;
    }
    function handleFocus(e) {
      const target = e.target;
      if (!wrapper.contains(target)) {
        return;
      }
      const targetTag = target.tagName ? target.tagName.toLowerCase() : '';
      if (target.tabIndex >= 0 || INTERACTIVE_ELEMENT_TAGS.includes(targetTag)) {
        scrollIntoViewWithOffset(target, {
          offsetTop,
          offsetBottom
        });
      }
    }
    wrapper.addEventListener('focusin', handleFocus);
    return () => {
      wrapper.removeEventListener('focusin', handleFocus);
    };
  }, [offsetTop, offsetBottom]);
  return wrapperRef;
};
setGlobal('svs.components.lbUtils.assistedFocusScroll', {
  useAssistedFocusScroll
});

 })(window);